import { Box } from "@mui/material";
import "./App.css";
import Pages from "./pages/index";
import Login from "./pages/Login";
import { useAuth } from "./contexts/AuthContext";

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <div>Loading...</div>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <Pages />;
}

export default App;
